import React from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import { useNavigate } from "react-router-dom";
import PolePlanting from "./PolePlanting";

function UpdatePolePlanting() {
  const navigation = useNavigate();

  return (
    <AppContainer title="Installation Details">
      <div className="card custom-card main-content-body-profile">
        <div className="card-body tab-content h-100">
          <h4 className="card-title">Update pole Planting</h4>

          <PolePlanting navi={navigation} />
        </div>
      </div>
    </AppContainer>
  );
}

export default UpdatePolePlanting;
